import { motion } from 'framer-motion';
import { 
  HiOutlineMail, 
  HiOutlineLocationMarker, 
  HiOutlinePhone,
  HiOutlineCreditCard
} from 'react-icons/hi';
import { FaFax, FaBuilding, FaUser, FaIdCard } from 'react-icons/fa';
import './Footer.scss';

const Footer = () => {
  const currentYear = '2025';

  const companyInfo = [
    { icon: '', label: '회사명', value: '오토젠소프트' },
    { icon: '', label: '대표번호', value: '1800-0981' },
    { icon: '', label: '사업자등록번호', value: '122-36-25111' },
    { icon: '', label: '개인정보책임자', value: '한운섭' },
  ];

  const contactInfo = [
    { icon: '', label: '대표', value: '한운섭' },
    { icon: '', label: '이메일', value: 'mathautogen@naver.com' },
    { icon: '', label: '주소', value: '인천광역시 부평구 마장로 256 403호 (산곡프라자)' },
    { icon: '', label: '입금계좌', value: '하나은행 630-009893-198 (예금주: 오토젠소프트)' },
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        <motion.div 
          className="footer__top"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="footer__brand">
            <h3 className="footer__logo">
              <span className="footer__logo-math">매쓰오토</span>
              <span className="footer__logo-gen">젠</span>
            </h3>
      
          </div>

          <div className="footer__info">
            <div className="footer__section">
              <ul className="footer__list">
                {companyInfo.map((item, index) => (
                  <li key={index} className="footer__list-item">
                    <span className="footer__icon">{item.icon}</span>
                    <span className="footer__label">{item.label}:</span>
                    <span className="footer__value">{item.value}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__section">
              <ul className="footer__list">
                {contactInfo.map((item, index) => (
                  <li key={index} className="footer__list-item">
                    <span className="footer__icon">{item.icon}</span>
                    <span className="footer__label">{item.label}:</span>
                    <span className="footer__value">{item.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </motion.div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} MathAutoGen. All rights reserved.
          </p>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
